<template>
  <Modal v-model:is-open="confirm_cancel_modal" max-width="max-w-[600px] mx-5">
    <template #form="{}">
      <div class="max-w-xl mt-2 text-sm text-gray-500">
        <p>{{ $t("There are changes made, are you sure you want to cancel?") }}</p>
      </div>
      <div class="mt-5 text-center">
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 font-medium text-red-700 bg-red-100 border border-transparent rounded-md hover:bg-red-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:text-sm"
          @click="handleCancelChanges">
          {{ $t("Yes, cancel changes") }}
        </button>
        <button
          type="button"
          class="inline-flex items-center justify-center px-4 py-2 ml-2 font-medium border rounded-md dark:text-dark-body-text focus:outline-none focus:ring-2 focus:ring-offset-2 sm:text-sm"
          @click="confirm_cancel_modal = false">
          {{ $t("Go back") }}
        </button>
      </div>
    </template>
  </Modal>

  <div :class="[classes]">
    <div class="bg-gradient-to-b from-[#B0D0FF]/70 h-36 w-[100%] absolute left-0 top-0 pointer-events-none" />

    <div class="text-3xl font-medium relative z-10 flex space-x-2">
      <Settings2 class="mr-2 w-10 h-10" color="black" /> {{ $t("Manage Menu") }}
    </div>
    <div class="relative z-10 text-common-grey text-sm ml-12 -mt-2">
      {{ $t("Create, rearrange, edit and delete menu items.") }}
    </div>
    <div class="relative flex h-full gap-2 justify-between mt-6">
      <Listbox as="div" class="w-[48%] h-full">
        <div class="relative flex flex-col justify-center w-full">
          <div class="font-medium whitespace-nowrap text-xl flex justify-between">
            <div>
              {{ translatedAvailableItemsLabel }}
            </div>
            <div class="relative">
              <button
                v-tooltip="'Add New'"
                type="button"
                class="icon-circle-btn primary-btn"
                @click="show_plus_btn_options = !show_plus_btn_options">
                <Plus class="h-5 w-5 text-white" aria-hidden="true" />
              </button>

              <transition name="fade">
                <div
                  v-if="show_plus_btn_options"
                  class="absolute top-10 -left-10 z-10 mt-2 w-fit rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5">
                  <button v-tooltip="'Add Page'" type="button" class="icon-circle-btn m-1 hover:bg-gray-100" @click="addNewPage('left')">
                    <FilePlus class="h-5 w-5 text-gray-500" aria-hidden="true" />
                  </button>
                  <button v-tooltip="'Add Group'" type="button" class="icon-circle-btn m-1 hover:bg-gray-100" @click="addNewGroup('left')">
                    <FolderPlus class="h-5 w-5 text-gray-500" aria-hidden="true" />
                  </button>
                  <button
                    v-if="currentItem.name == 'Portfolio' && missing_objects_pages?.size > 0"
                    v-tooltip="`Inject Missing Objects Pages (${missing_objects_pages?.size})`"
                    type="button"
                    class="icon-circle-btn m-1 hover:bg-gray-100"
                    @click="refreshObjectsPages">
                    <RotateCw class="h-5 w-5 text-gray-700" aria-hidden="true" />
                  </button>
                </div>
              </transition>
            </div>
          </div>
          <div class="flex flex-row-reverse items-center gap-4 text-common-grey">
            <div class="relative w-full h-[50px] flex items-center flex-row-reverse">
              <div class="absolute flex items-center justify-center w-5 h-full right-2">
                <transition name="fade" mode="out-in" duration="100">
                  <X
                    v-if="hidden_pages_search_value"
                    color="#899399"
                    class="w-6 h-6 text-common-grey cursor-pointer"
                    @click="
                      () => {
                        hidden_pages_active = false
                        hidden_pages_search_value = ''
                      }
                    " />
                </transition>
              </div>
              <input
                ref="leftListSearch"
                v-model="hidden_pages_search_value"
                label=""
                :class="['opacity-100 w-full']"
                class="block w-full px-3 py-2 placeholder-gray-400 transition-all ease-in border border-gray-300 rounded-md shadow-sm appearance-none dark:bg-dark-box-background dark:text-white dark:border-dark-divider-border focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                name="name"
                autocomplete="off"
                :autofocus="true"
                tabindex="0"
                type="text"
                :placeholder="$t('Search page')">
            </div>
          </div>
          <div class="w-full" @keydown.ctrl.a="selectDeselectAllItemsHandler(hidden_pages_items, is_hidden_pages_all_selected)">
            <draggable
              v-if="!hide_hidden_pages"
              id="left-list"
              :key="rerender_trigger"
              v-model="hidden_pages_items"
              :disabled="hidden_pages_search_value"
              as="ListboxOptions"
              static
              :class="[
                'bg-white dark:border-dark-divider-border border-white dark:bg-dark-box-background',
                ` h-[55vh] overflow-scroll mt-1 border-0 ${
                  $store.state.ui.darkMode ? 'dark-scrollbar' : ''
                } dark:border-dark-divider-border rounded-lg text-base ring-0 overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration`
              ]"
              :component-data="{
                type: 'transition-group',
                name: !drag ? 'flip-list' : null
              }"
              v-bind="{
                sort: !disable_sort && !hidden_pages_search_value,
                animation: 200,
                group: 'group',
                ghostClass: 'ghost',
                chosenClass: 'chosen'
              }"
              item-key="id"
              @start="startDragToRightList()"
              @end="endDragToRightList()">
              <template #item="{ element }">
                <ListboxOption
                  :key="element.id"
                  :class="{
                    'bg-dark-brand-blue/10 hover:bg-dark-brand-blue/20 mx-2 rounded-md border border-dashed border-dark-brand-blue':
                      element.is_group,
                    'hover:bg-gray-100': !element.is_group
                  }"
                  class=""
                  as="template"
                  :value="getValue(element)">
                  <div
                    :class="[
                      `flex !cursor-move group !opacity-100  relative py-2 ${
                        element.is_group ? 'pl-6 my-2 py-1' : 'pl-8'
                      } group/row pr-4 transition ease-in-out duration-side-menu-transition-duration flex-col`
                    ]">
                    <div
                      v-if="creating_group && element_currently_dragged?.id == element.id"
                      class="absolute z-50 -mt-10 right-6 bg-gray-200 p-1 rounded-md">
                      {{ $t("Creating group") }}: <LoadingBar class="ml-2" />
                    </div>

                    <div class="w-full" :class="['text-common-grey ', 'block transition ease-in duration-side-menu-transition-duration']">
                      <div class="flex items-center">
                        <input
                          :checked="
                            element.is_group ? element.pages.filter((p) => p.selected).length == element.pages.length : element.selected
                          "
                          type="checkbox"
                          class="mr-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:!bg-light-brand-blue dark:checked:bg-dark-brand-blue dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-light-divider-border w-4 rounded h-4 transition ease-in-out duration-side-menu-transition-duration"
                          @click.stop="handleSelectItem(element)">

                        <TextInput
                          v-if="element.is_static && element.objectType"
                          :value="element.name"
                          label=""
                          :classes="'w-full'"
                          input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="name"
                          type="text"
                          :placeholder="$t('Object type label')"
                          :validate-on-input="true"
                          @click.stop
                          @blurred="updateObjectTypeLabel(element)"
                          @update:modelValue="
                            ($event) => {
                              element.name = $event
                            }
                          " />
                        <TextInput
                          v-else
                          :value="element.name"
                          label=""
                          :classes="'w-full'"
                          input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="name"
                          type="text"
                          :placeholder="$t('Page name')"
                          @click.stop
                          @update:modelValue="
                            ($event) => {
                              element.name = $event
                              handleUpdateGroupName(element, $event)
                            }
                          " />
                      </div>

                      <div
                        v-if="element.is_group"
                        :ref="`${element.id}`"
                        class="w-full"
                        @keydown.ctrl.a="selectDeselectAllItemsHandler(visible_pages_items, visible_pages_all_selected)">
                        <draggable
                          :id="`left-list-${element.name}`"
                          v-model="element.pages"
                          :disabled="hidden_pages_search_value"
                          as="ListboxOptions"
                          static
                          :class="[
                            'bg-transparent dark:border-dark-divider-border border-white dark:bg-dark-box-background',
                            `list-group min-h-[100px] w-[340px]  mt-1 overflow-scroll border-0 ${
                              $store.state.ui.darkMode ? 'dark-scrollbar' : ''
                            } dark:border-dark-divider-border  text-base  overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration`
                          ]"
                          :component-data="{
                            type: 'transition-group',
                            name: !drag ? 'flip-list' : null
                          }"
                          v-bind="{
                            type: 'transition-group',
                            sort: !disable_sort && !hidden_pages_search_value,
                            animation: 200,
                            group: `group`,
                            ghostClass: 'ghost',
                            chosenClass: 'chosen'
                          }"
                          item-key="id"
                          @start="startDragToLeftList()"
                          @end="endDragToLeftList()">
                          <template #item="{ element: page_element }">
                            <ListboxOption
                              :key="page_element.id"
                              class="!cursor-move hover:bg-gray-100"
                              as="template"
                              :value="getValue(page_element)">
                              <div
                                :class="[
                                  `flex group  !opacity-100  cursor-default relative pl-8 py-2 pr-4 transition ease-in-out duration-side-menu-transition-duration`
                                ]">
                                <input
                                  :checked="page_element.selected"
                                  type="checkbox"
                                  class="mr-2 mt-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-light-divider-border w-4 rounded h-4 transition ease-in-out duration-side-menu-transition-duration"
                                  @click.stop="handleSelectItem(page_element)">

                                <div
                                  class="w-72"
                                  :class="[
                                    page_element.selected
                                      ? 'text-light-body-text dark:text-dark-body-text group-hover:text-dark-body-text dark:group-hover:text-light-body-text'
                                      : 'text-common-grey group-hover:text-dark-body-text',
                                    'block transition ease-in duration-side-menu-transition-duration'
                                  ]">
                                  <TextInput
                                    :value="page_element.name"
                                    label=""
                                    :classes="'w-full'"
                                    input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                                    name="name"
                                    type="text"
                                    :placeholder="$t('Page name')"
                                    @click.stop
                                    @update:modelValue="
                                      ($event) => {
                                        page_element.name = $event
                                      }
                                    " />
                                </div>
                              </div>
                            </ListboxOption>
                          </template>
                        </draggable>
                      </div>
                    </div>
                    <div
                      v-if="element.objectType"
                      class="opacity-0 group-hover/row:opacity-100 absolute cursor-pointer right-5 top-4 has-tooltip">
                      <Info class="w-6 h-6 text-common-grey" aria-hidden="true" />
                      <div
                        class="flex gap-2 px-2 py-2 text-sm text-center font-medium border rounded-md tooltip -ml-36 border-dark-brand-blue dark:border-dark-grey-text bg-light-screen-background dark:bg-dark-screen-background dark:text-dark-body-text">
                        <span>{{ $utils.getObjectTypeByType(element?.objectType).type }}</span><br>
                        <span class="capitalize">{{
                          $utils
                            .getObjectTypeByType(element?.objectType)
                            ?.origins_types?.filter((c) => c.origin.toLowerCase() != "platform" && c.origin.toLowerCase() != "rs_datahub")
                            .map((o) => o.origin)
                            .join(",")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </ListboxOption>
              </template>
            </draggable>

            <div class="flex mt-4 justify-center w-full space-x-2">
              <button
                v-if="hidden_pages_selected_dynamic_count"
                class="btn cancel-btn text-white font-normal bg-red-400 hover:bg-red-500 hover:text-white border-red-400"
                @click="handleDeleteLeftPages()">
                {{ $t("Delete") }} {{ hidden_pages_selected_dynamic_count }}
                {{ hidden_pages_selected_dynamic_count > 1 ? "pages" : "page" }}
              </button>

              <button
                v-if="hidden_pages_items.length"
                class="btn cancel-btn text-common-grey font-normal"
                @click="selectDeselectAllItemsHandler(hidden_pages_items, is_hidden_pages_all_selected)">
                {{ is_hidden_pages_all_selected ? $t("Deselect") : $t("Select") }} {{ $t("all Items") }}
              </button>
            </div>
          </div>
        </div>
      </Listbox>

      <div class="w-[4%] flex flex-col justify-center items-center border-r-2 relative right-4 border-gray-100">
        <div class="flex flex-col items-center justify-center gap-1 relative left-4">
          <transition-group key="control" name="vertical-list">
            <div
              v-if="hidden_pages_selected_count > 0"
              id="add-item"
              key="add-item"
              class="relative w-8 h-8 overflow-hidden font-medium text-center text-gray-500 rounded-full cursor-pointer bg-white dark:hover:opacity-80 focus:outline-none active:bg-gray-200"
              @click="moveSelectedToSecondList">
              <transition name="slide-left" duration="200">
                <CircleArrowRight
                  color="#27C884"
                  class="absolute inset-0 w-8 h-8 m-auto"
                  :class="[$store.state.portfolio.ui_options?.language == 'ar' ? 'rotate-180' : '']" />
              </transition>
            </div>

            <div
              v-if="visible_pages_selected_count > 0"
              id="remove-item"
              key="remove-item"
              class="relative w-8 h-8 overflow-hidden font-medium text-center text-gray-500 rounded-full cursor-pointer bg-white dark:hover:opacity-80 focus:outline-none active:bg-gray-200"
              @click="moveSelectedToFirstList">
              <transition name="slide-right" duration="200">
                <CircleArrowRight
                  color="#F05B5B"
                  class="absolute inset-0 w-8 h-8 m-auto"
                  :class="[$store.state.portfolio.ui_options?.language == 'ar' ? '' : 'rotate-180']" />
              </transition>
            </div>
          </transition-group>
        </div>
      </div>

      <Listbox as="div" class="h-full w-[48%]">
        <div class="mt-2 relative flex flex-col justify-center w-full">
          <span class="font-medium whitespace-nowrap text-xl">
            {{ translatedSelectedItemsLabel }}
          </span>
          <div class="flex flex-row-reverse items-center gap-4 text-common-grey">
            <div class="relative w-full h-[50px] flex items-center flex-row-reverse">
              <div class="absolute flex items-center justify-center w-5 h-full right-2">
                <transition name="fade" mode="out-in" duration="100">
                  <X
                    v-if="visible_pages_search_value"
                    color="#899399"
                    class="w-6 h-6 text-gray-400 cursor-pointer"
                    @click="
                      () => {
                        visible_pages_active = false
                        visible_pages_search_value = ''
                      }
                    " />
                </transition>
              </div>
              <div
                v-if="
                  !disableGrouping &&
                    !element_currently_dragged?.is_group &&
                    visible_pages_items.map((i) => i.id).includes(element_currently_dragged?.id)
                ">
                {{ $t("Hold to create group") }}
              </div>

              <input
                v-else
                ref="rightListSearch"
                v-model="visible_pages_search_value"
                label=""
                tabindex="0"
                autocomplete="off"
                :class="['opacity-100 w-full']"
                class="block w-full px-3 py-2 placeholder-gray-400 transition-all ease-in border border-gray-300 rounded-md shadow-sm appearance-none dark:bg-dark-box-background dark:text-white dark:border-dark-divider-border focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                name="name"
                type="text"
                :placeholder="$t('Search page')">
            </div>
          </div>
          <div class="w-full" @keydown.ctrl.a="selectDeselectAllItemsHandler(visible_pages_items, visible_pages_all_selected)">
            <draggable
              v-if="!visible_pages"
              id="right-list"
              :key="rerender_trigger"
              v-model="visible_pages_items"
              :disabled="visible_pages_search_value"
              as="ListboxOptions"
              static
              :class="[
                'bg-white dark:border-dark-divider-border border-white dark:bg-dark-box-background',
                `list-group  h-[55vh] mt-1 overflow-scroll border-0 ${
                  $store.state.ui.darkMode ? 'dark-scrollbar' : ''
                } dark:border-dark-divider-border rounded-lg text-base overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration`
              ]"
              :component-data="{
                type: 'transition-group',
                name: !drag ? 'flip-list' : null
              }"
              v-bind="{
                type: 'transition-group',
                sort: !disable_sort && !visible_pages_search_value,
                animation: 200,
                group: 'group',
                ghostClass: 'ghost',
                chosenClass: 'chosen'
              }"
              item-key="id"
              @start="startDragToLeftList()"
              @end="endDragToLeftList()">
              <template #item="{ element }">
                <ListboxOption
                  :key="element.id"
                  :class="{
                    'bg-dark-brand-blue/10 hover:bg-dark-brand-blue/20 mx-2 rounded-md border border-dashed border-dark-brand-blue':
                      element.is_group,
                    'hover:bg-gray-100': !element.is_group,
                    'pointer-events-none !opacity-40': element.slug == 'overview' || element.slug == 'home'
                  }"
                  class="!cursor-move"
                  as="template"
                  :value="getValue(element)">
                  <div
                    :class="[
                      `flex !cursor-move group !opacity-100  relative py-2 ${
                        element.is_group ? 'pl-6 my-2 py-1' : 'pl-8'
                      }  pr-4 transition ease-in-out duration-side-menu-transition-duration`
                    ]">
                    <div
                      v-if="creating_group && element_currently_dragged?.id == element.id"
                      class="absolute z-50 -mt-10 right-6 bg-gray-200 p-1 rounded-md">
                      {{ $t("Creating group") }}: <LoadingBar class="ml-2" />
                    </div>

                    <div class="w-80" :class="['text-common-grey ', 'block transition ease-in duration-side-menu-transition-duration']">
                      <div class="flex items-center">
                        <input
                          :checked="
                            element.is_group ? element.pages.filter((p) => p.selected).length == element.pages.length : element.selected
                          "
                          type="checkbox"
                          class="mr-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-light-divider-border w-4 rounded h-4 transition ease-in-out duration-side-menu-transition-duration"
                          @click.stop="handleSelectItem(element)">
                        <TextInput
                          v-if="element.is_static && element.objectType"
                          :value="element.name"
                          label=""
                          :classes="'w-full'"
                          input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="name"
                          type="text"
                          :placeholder="$t('Object type label')"
                          :validate-on-input="true"
                          @click.stop
                          @blurred="updateObjectTypeLabel(element)"
                          @update:modelValue="
                            ($event) => {
                              element.name = $event
                            }
                          " />

                        <TextInput
                          v-else
                          :value="element.slug == 'home' ? 'Home (locked)' : element.name"
                          label=""
                          :classes="'w-full'"
                          input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                          name="name"
                          type="text"
                          :placeholder="$t('Group name')"
                          @click.stop
                          @update:modelValue="
                            ($event) => {
                              element.name = $event
                              handleUpdateGroupName(element, $event)
                            }
                          " />
                      </div>

                      <div
                        v-if="element.is_group"
                        :ref="`${element.id}`"
                        class="w-full"
                        @keydown.ctrl.a="selectDeselectAllItemsHandler(visible_pages_items, visible_pages_all_selected)">
                        <draggable
                          :id="`right-list-${element.name}`"
                          v-model="element.pages"
                          :disabled="visible_pages_search_value"
                          as="ListboxOptions"
                          static
                          :class="[
                            'bg-transparent dark:border-dark-divider-border border-white dark:bg-dark-box-background',
                            `list-group min-h-[50px] w-[340px]  mt-1 overflow-scroll border-0 ${
                              $store.state.ui.darkMode ? 'dark-scrollbar' : ''
                            } dark:border-dark-divider-border  text-base overflow-auto focus:outline-none sm:text-sm transition ease-in-out duration-side-menu-transition-duration`
                          ]"
                          :component-data="{
                            type: 'transition-group',
                            name: !drag ? 'flip-list' : null
                          }"
                          v-bind="{
                            type: 'transition-group',
                            sort: !disable_sort && !visible_pages_search_value,

                            animation: 200,
                            group: `group`,
                            ghostClass: 'ghost',
                            chosenClass: 'chosen'
                          }"
                          item-key="id"
                          @start="startDragToLeftList()"
                          @end="endDragToLeftList()">
                          <template #item="{ element: page_element }">
                            <ListboxOption
                              :key="page_element.id"
                              class="!cursor-move hover:bg-gray-100"
                              as="template"
                              :value="getValue(page_element)">
                              <div
                                :class="[
                                  `flex group  cursor-default relative py-2 pl-8 pr-4 transition ease-in-out duration-side-menu-transition-duration`
                                ]">
                                <input
                                  :checked="page_element.selected"
                                  type="checkbox"
                                  class="mr-2 mt-2 form-checkbox text-light-brand-blue dark:text-dark-brand-blue checked:bg-light-brand-blue dark:checked:bg-dark-brand-blue dark:bg-dark-box-background border-[2px] focus:ring-0 ring-dark/0 border-light-divider-border w-4 rounded h-4 transition ease-in-out duration-side-menu-transition-duration"
                                  @click.stop="handleSelectItem(page_element)">

                                <div
                                  class="w-72"
                                  :class="[
                                    'text-common-grey group-hover:text-dark-body-text',
                                    'block transition ease-in duration-side-menu-transition-duration'
                                  ]">
                                  <TextInput
                                    v-if="page_element.is_static && page_element.objectType"
                                    :value="page_element.name"
                                    label=""
                                    :classes="'w-full'"
                                    input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                                    name="name"
                                    type="text"
                                    :placeholder="$t('Object type label')"
                                    :validate-on-input="true"
                                    @click.stop
                                    @blurred="updateObjectTypeLabel(page_element)"
                                    @update:modelValue="
                                      ($event) => {
                                        page_element.name = $event
                                      }
                                    " />

                                  <TextInput
                                    v-else
                                    :value="page_element.name"
                                    label=""
                                    :classes="'w-full'"
                                    input-classes="appearance-none cursor-move block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-blue-light focus:border-blue-light sm:text-sm"
                                    name="name"
                                    type="text"
                                    :placeholder="`${page_element.is_group ? $t('Group') : $t('Page')} ` + $t('name')"
                                    @click.stop
                                    @update:modelValue="
                                      ($event) => {
                                        page_element.name = $event
                                      }
                                    " />
                                </div>
                              </div>
                            </ListboxOption>
                          </template>
                        </draggable>
                      </div>
                    </div>
                  </div>
                </ListboxOption>
              </template>
            </draggable>
            <div class="flex mt-4 justify-center w-full space-x-2">
              <button
                v-if="visible_pages_selected_dynamic_count"
                class="btn cancel-btn text-white font-normal bg-red-400 hover:bg-red-500 hover:text-white border-red-400"
                @click="handleDeleteRightPages()">
                {{ $t("Delete") }} {{ visible_pages_selected_dynamic_count }} {{ $t("page") }}
                {{ visible_pages_selected_dynamic_count > 1 ? "s" : "" }}
              </button>

              <button
                v-if="visible_pages_items.length"
                class="btn cancel-btn text-common-grey font-normal"
                @click="selectDeselectAllItemsHandler(visible_pages_items, visible_pages_all_selected)">
                {{ visible_pages_all_selected ? $t("Deselect") : $t("Select") }} {{ $t("all Items") }}
              </button>
            </div>
          </div>
        </div>
      </Listbox>
    </div>

    <div class="flex justify-between w-full mt-4 space-x-2 items-center">
      <div class="cursor-pointer text-light-brand-blue" @click="handleCancel">
        {{ $t("Cancel") }}
      </div>
      <button
        v-if="(visible_pages_changes > 0 || hidden_pages_changes > 0) && !hidden_pages_search_value && !visible_pages_search_value"
        class="primary-btn w-fit"
        @click="handleSubmit">
        {{ $t("Save Changes") }}
      </button>
    </div>
  </div>
</template>

<script>
import draggable from "vuedraggable"
// eslint-disable-next-line vue/no-unused-components
import { Listbox, ListboxOptions, ListboxOption } from "@headlessui/vue"
import { utils } from "@/store/helpers"
import Modal from "@/components/shared/Modal.vue"
import { v4 as uuid4 } from "uuid"
import TextInput from "@/components/shared/TextInput.vue"
import LoadingBar from "@/components/shared/LoadingBar.vue"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import getPageDefaultLayout from "@/components/shared/pages/default-layouts/index.js"
import ObjectTypesService from "@/services/object_types.service"
import { Plus, Settings2, RotateCw, Info, FilePlus, FolderPlus, X, CircleArrowRight } from "lucide-vue-next"

export default {
  components: {
    RotateCw,
    FilePlus,
    FolderPlus,
    Info,
    Plus,
    LoadingBar,
    Modal,
    TextInput,
    Listbox,
    // eslint-disable-next-line vue/no-unused-components
    ListboxOptions,
    ListboxOption,
    draggable,
    Settings2,
    X,
    CircleArrowRight
  },

  inject: ["setPageLayout", "updateLayouts"],
  props: {
    disableGrouping: {
      type: Boolean,
      default: false
    },

    classes: {
      type: String,
      default: ""
    },
    // Value is a list of metrics that are included or selected in the second list
    // Displayed metrics list
    currentItem: {
      type: Object,
      required: true
    },

    availableItemsLabel: {
      type: String,
      default: "All Pages"
    },
    selectedItemsLabel: {
      type: String,
      default: "Selected Pages"
    },
    valueAttr: {
      validator(v) {
        return v !== undefined
      }
    }
  },

  emits: ["update:currentItems", "search", "cancel", "done"],

  data() {
    return {
      hidden_pages_search_value: "",
      visible_pages_search_value: "",
      show_plus_btn_options: false,
      drag: false,
      element_currently_dragged: null,
      element_dragged_over: null,
      hidden_pages_items: [],
      hidden_pages_items_original: [],
      visible_pages_items_original: [],
      visible_pages_items: [],
      hidden_pages_active: false,
      visible_pages_active: false,
      tmp_list: [],
      disable_sort: false,
      hide_hidden_pages: false,
      visible_pages: false,
      rerender_trigger: 0,
      dont_trigger_hidden_pages_items_watch: false,
      visible_pages_items_watch: false,
      pages_deleted: [],
      hidden_pages_changes: -1,
      visible_pages_changes: -1,
      confirm_cancel_modal: false,
      creating_group: false
    }
  },
  computed: {
    translatedAvailableItemsLabel() {
      return this.$t(this.availableItemsLabel)
    },
    translatedSelectedItemsLabel() {
      return this.$t(this.selectedItemsLabel)
    },
    missing_objects_pages() {
      try {
        
        let objects = new Set(this.$store.state.object_types.map((o) => o.type))
        let existing_objects = new Set(this.$store.state.portfolio.pages_layout["portfolio"].map((p) => p.objectType || p.slug))
        
        // Also check for object types in visible_pages_items (right side)
        let visible_object_types = new Set(this.visible_pages_items
        .filter(item => item.objectType)
        .map(item => item.objectType))
        
        // Combine existing objects from both sources
        let all_existing_objects = new Set([...existing_objects, ...visible_object_types])
        
        return new Set([...objects].filter((x) => !all_existing_objects.has(x)))
      } catch (_) {
        return new Set([]) 
      }
    },
    hidden_pages_selected_count() {
      let selected_count = 0
      this.hidden_pages_items.forEach((item) => {
        if (item.is_group) {
          const pages_selected_count = item.pages.filter((p) => p.selected).length
          selected_count += pages_selected_count
        } else if (item.selected) {
          selected_count += 1
        }
      })
      return selected_count
    },
    visible_pages_selected_count() {
      let selected_count = 0
      this.visible_pages_items.forEach((item) => {
        if (item.is_group) {
          const pages_selected_count = item.pages.filter((p) => p.selected).length
          selected_count += pages_selected_count
        } else if (item.selected) {
          selected_count += 1
        }
      })
      return selected_count
    },

    hidden_pages_selected_dynamic_count() {
      let selected_count = 0
      this.hidden_pages_items.forEach((item) => {
        if (item.is_group) {
          const pages_selected_count = item.pages.filter((p) => p.selected).length
          selected_count += pages_selected_count
        } else if (item.selected) {
          selected_count += 1
        }
      })
      return selected_count
    },
    visible_pages_selected_dynamic_count() {
      let selected_count = 0
      this.visible_pages_items.forEach((item) => {
        if (item.is_group) {
          const pages_selected_count = item.pages.filter((p) => p.selected).length
          selected_count += pages_selected_count
        } else if (item.selected) {
          selected_count += 1
        }
      })
      return selected_count
    },

    is_hidden_pages_all_selected() {
      let all_selected = true

      this.hidden_pages_items.forEach((item) => {
        if (item.is_group) {
          if (item.pages.filter((p) => !p.selected).length) {
            all_selected = false
          }
        } else if (!item.selected) {
          all_selected = false
        }
      })
      return all_selected
    },
    visible_pages_all_selected() {
      let all_selected = true

      this.visible_pages_items.forEach((item) => {
        if (item.is_group) {
          if (item.pages.filter((p) => !p.selected).length) {
            all_selected = false
          }
        } else if (!item.selected) {
          all_selected = false
        }
      })
      return all_selected
    }
  },

  watch: {
    hidden_pages_items: {
      deep: true,
      handler() {
        if (!this.dont_trigger_hidden_pages_items_watch) {
          this.hidden_pages_changes += 1
          const clean_list = []
          const hidden_pages_items_clone = this.$utils.clone(this.hidden_pages_items)
          hidden_pages_items_clone.forEach((item) => {
            if (item.is_group && !item.pages.length) {
              //dont add
            } else {
              clean_list.push(item)
            }
          })
          this.dont_trigger_hidden_pages_items_watch = true
          this.hidden_pages_items = clean_list

          if (this.hidden_pages_search_value) {
            const hidden_pages_items_original_calc = []
            this.hidden_pages_items_original.forEach((item) => {
              if (this.hidden_pages_items.find((hidden_pages_item) => hidden_pages_item.id == item.id)) {
                if (item.is_group) {
                  const group_pages_calc = []
                  item.pages.forEach((page) => {
                    if (
                      this.hidden_pages_items
                        .find((hidden_pages_item) => hidden_pages_item.id == item.id)
                        .pages.find((p) => p.id == page.id)
                    ) {
                      group_pages_calc.push(
                        this.hidden_pages_items
                          .find((hidden_pages_item) => hidden_pages_item.id == item.id)
                          .pages.find((p) => p.id == page.id)
                      )
                    } else {
                      group_pages_calc.push(page)
                    }
                  })
                  hidden_pages_items_original_calc.push({
                    ...this.hidden_pages_items.find((hidden_pages_item) => hidden_pages_item.id == item.id),
                    pages: group_pages_calc
                  })
                } else {
                  hidden_pages_items_original_calc.push(
                    this.hidden_pages_items.find((hidden_pages_item) => hidden_pages_item.id == item.id)
                  )
                }
              } else {
                hidden_pages_items_original_calc.push(item)
              }
            })
            this.hidden_pages_items_original = hidden_pages_items_original_calc
          } else {
            if (this.hidden_pages_items_original.length) {
              this.hidden_pages_items_original = this.$utils.clone(this.hidden_pages_items)
            }
          }

          setTimeout(() => {
            this.dont_trigger_hidden_pages_items_watch = false
          }, 300)
        }
      }
    },
    visible_pages_items: {
      deep: true,
      handler() {
        if (!this.visible_pages_items_watch) {
          this.visible_pages_changes += 1
          const clean_list = []
          const visible_pages_items_clone = this.$utils.clone(this.visible_pages_items)
          visible_pages_items_clone.forEach((item) => {
            if (item.is_group && !item.pages.length) {
              //dont add
            } else {
              clean_list.push(item)
            }
          })
          this.visible_pages_items_watch = true
          this.visible_pages_items = clean_list

          if (this.visible_pages_search_value) {
            const visible_pages_items_original_calc = []
            this.visible_pages_items_original.forEach((item) => {
              if (this.visible_pages_items.find((visible_pages_item) => visible_pages_item.id == item.id)) {
                if (item.is_group) {
                  const group_pages_calc = []
                  item.pages.forEach((page) => {
                    if (
                      this.visible_pages_items
                        .find((visible_pages_item) => visible_pages_item.id == item.id)
                        .pages.find((p) => p.id == page.id)
                    ) {
                      group_pages_calc.push(
                        this.visible_pages_items
                          .find((visible_pages_item) => visible_pages_item.id == item.id)
                          .pages.find((p) => p.id == page.id)
                      )
                    } else {
                      group_pages_calc.push(page)
                    }
                  })
                  visible_pages_items_original_calc.push({
                    ...this.visible_pages_items.find((visible_pages_item) => visible_pages_item.id == item.id),
                    pages: group_pages_calc
                  })
                } else {
                  visible_pages_items_original_calc.push(
                    this.visible_pages_items.find((visible_pages_item) => visible_pages_item.id == item.id)
                  )
                }
              } else {
                visible_pages_items_original_calc.push(item)
              }
            })
            this.visible_pages_items_original = visible_pages_items_original_calc
          } else {
            if (this.visible_pages_items_original.length) {
              this.visible_pages_items_original = this.$utils.clone(this.visible_pages_items)
            }
          }

          setTimeout(() => {
            this.visible_pages_items_watch = false
          }, 300)
        }
      }
    },

    hidden_pages_search_value() {
      const hidden_pages_calc = []
      this.hidden_pages_items_original.forEach((item) => {
        if (item.is_group) {
          if (item.name.toLowerCase().includes(this.hidden_pages_search_value.toLowerCase())) {
            hidden_pages_calc.push(item)
          } else {
            const group_pages_calc = []
            item.pages.forEach((page) => {
              if (page.name.toLowerCase().includes(this.hidden_pages_search_value)) {
                group_pages_calc.push(page)
              }
            })

            if (group_pages_calc.length) {
              hidden_pages_calc.push({ ...item, pages: group_pages_calc })
            }
          }
        } else {
          if (item.name.toLowerCase().includes(this.hidden_pages_search_value.toLowerCase())) {
            hidden_pages_calc.push(item)
          }
        }
      })
      this.hidden_pages_items = hidden_pages_calc
      this.dont_trigger_hidden_pages_items_watch = true
      setTimeout(() => {
        this.dont_trigger_hidden_pages_items_watch = false
      }, 200)
    },

    visible_pages_search_value() {
      const visible_pages_calc = []
      this.visible_pages_items_original.forEach((item) => {
        if (item.is_group) {
          if (item.name.toLowerCase().includes(this.visible_pages_search_value.toLowerCase())) {
            visible_pages_calc.push(item)
          } else {
            const group_pages_calc = []
            item.pages.forEach((page) => {
              if (page.name.toLowerCase().includes(this.visible_pages_search_value)) {
                group_pages_calc.push(page)
              }
            })

            if (group_pages_calc.length) {
              visible_pages_calc.push({ ...item, pages: group_pages_calc })
            }
          }
        } else {
          if (item.name.toLowerCase().includes(this.visible_pages_search_value.toLowerCase())) {
            visible_pages_calc.push(item)
          }
        }
      })
      this.visible_pages_items_watch = true
      this.visible_pages_items = visible_pages_calc
      setTimeout(() => {
        this.visible_pages_items_watch = false
      }, 200)
    }
  },

  mounted() {
    const hidden_pages_grouped = []
    const hidden_pages_flat = this.$store.state.portfolio.pages_layout[this.currentItem.name.toLowerCase()]?.filter(
      (item) => item.is_hidden
    )

    let hidden_pages_flat_clean = []
    hidden_pages_flat_clean = hidden_pages_flat

    hidden_pages_flat_clean?.forEach((item) => {
      if (!item.group_name) {
        hidden_pages_grouped.push(item)
      } else {
        const index = hidden_pages_grouped.findIndex((g) => g?.name == item.group_name)
        if (index == -1) {
          hidden_pages_grouped.push({
            name: item.group_name,
            pages: [item],
            is_group: true,
            id: uuid4()
          })
        } else {
          hidden_pages_grouped[index].pages.push(item)
        }
      }
    })
    this.hidden_pages_items = utils.clone(hidden_pages_grouped)
    this.hidden_pages_items_original = [...this.hidden_pages_items]

    const visible_pages_grouped = []
    const visible_pages_flat = this.$store.state.portfolio.pages_layout[this.currentItem.name.toLowerCase()]?.filter(
      (item) => !item.is_hidden
    )
    visible_pages_flat?.forEach((item) => {
      if (!item.group_name) {
        visible_pages_grouped.push(item)
      } else {
        const index = visible_pages_grouped.findIndex((g) => g?.name == item.group_name)
        if (index == -1) {
          visible_pages_grouped.push({
            name: item.group_name,
            pages: [item],
            is_group: true,
            id: uuid4()
          })
        } else {
          visible_pages_grouped[index].pages.push(item)
        }
      }
    })
    this.visible_pages_items = utils.clone(visible_pages_grouped)
    this.visible_pages_items_original = utils.clone(this.visible_pages_items)
  },

  methods: {
    handleCancelChanges() {
      this.confirm_cancel_modal = false
      setTimeout(() => {
        this.$emit("cancel")
      }, 200)
    },
    handleSubmit() {
      const new_layout_calc = []

      this.visible_pages_items?.forEach((item) => {
        if (item.is_group) {
          item.pages.forEach((page) => {
            new_layout_calc.push({ ...page, is_hidden: false, group_name: item.name })
          })
        } else {
          new_layout_calc.push({ ...item, is_hidden: false, group_name: null })
        }
      })

      this.hidden_pages_items?.forEach((item) => {
        if (item.is_group) {
          item.pages.forEach((page) => {
            new_layout_calc.push({ ...page, is_hidden: true, group_name: item.name })
          })
        } else {
          new_layout_calc.push({ ...item, is_hidden: true, group_name: null })
        }
      })

      this.$emitter.emit(ALL_EMITTERS.PAGES_DELETED_IN_SIDE_MENU, {
        pages_deleted: this.pages_deleted,
        page_ref: this.currentItem.name.toLowerCase()
      })
      this.updateLayouts(new_layout_calc, this.currentItem.name.toLowerCase())
      this.$emit("done")
    },
    handleCancel() {
      if (this.hidden_pages_changes > 0 || this.visible_pages_changes > 0) {
        this.confirm_cancel_modal = true
      } else {
        this.$emit("cancel")
      }
    },
    handleDeleteLeftPages() {
      const new_hidden_pages_items = []
      this.hidden_pages_items?.forEach((item) => {
        if (item.is_group) {
          const new_pages = []
          item.pages.forEach((page) => {
            if (page.selected) {
              this.pages_deleted.push(page)
            } else {
              new_pages.push(page)
            }
          })

          if (new_pages.length) {
            new_hidden_pages_items.push({ ...item, pages: new_pages })
          }
        } else if (item.selected) {
          this.pages_deleted.push(item)
        } else {
          new_hidden_pages_items.push(item)
        }
        this.hidden_pages_items = new_hidden_pages_items
      })
    },

    handleDeleteRightPages() {
      const visible_pages_items = []
      this.visible_pages_items.forEach((item) => {
        if (item.is_group) {
          const new_pages = []
          item.pages.forEach((page) => {
            if (page.selected) {
              this.pages_deleted.push(page)
            } else {
              new_pages.push(page)
            }
          })

          if (new_pages.length) {
            visible_pages_items.push({ ...item, pages: new_pages })
          }
        } else if (item.selected) {
          this.pages_deleted.push(item)
        } else {
          visible_pages_items.push(item)
        }
        this.visible_pages_items = visible_pages_items
      })
    },

    createAllPortfolioDefaultTemplates() {
      // create all default objects missing pages for the portfolio
      const templates_calc = []
      if (this.missing_objects_pages.size) {
        this.missing_objects_pages.forEach((object_type) => {
          let layout = []
          let name = null
          let slug = null
          ;[layout, name, slug] = getPageDefaultLayout("portfolio", object_type)
          const template = {
            id: uuid4(),
            page: "portfolio",
            objectType: object_type,
            name: name,
            slug: slug,
            layout: layout,
            is_active: true,
            is_visible: false,
            is_static: true,
            group_name: null
          }
          templates_calc.push(template)
        })
        this.setPageLayout(templates_calc)
        // add all default objects missing pages in the left list
        this.hidden_pages_items = this.hidden_pages_items.concat(templates_calc)
      }
    },
    refreshObjectsPages() {
      this.createAllPortfolioDefaultTemplates()
      this.show_plus_btn_options = false
    },
    addNewGroup(list) {
      let group_index = this.visible_pages_items.concat(this.hidden_pages_items).filter((g) => g.is_group).length + 1
      let new_group = {
        name: this.$t("New Group") + ` ${group_index}`,
        id: uuid4(),
        is_group: true,
        pages: []
      }
      if (list == "left") {
        this.hidden_pages_items.splice(0, 1, new_group)
      } else {
        this.visible_pages_items.splice(0, 1, new_group)
      }

      if (list == "left") {
        this.dont_trigger_hidden_pages_items_watch = true
        this.hidden_pages_search_value = ""
        this.hidden_pages_active = false

        this.hidden_pages_changes += 1

        setTimeout(() => {
          this.dont_trigger_hidden_pages_items_watch = false
        }, 200)
      } else {
        this.visible_pages_items_watch = true
        this.visible_pages_search_value = ""
        this.visible_pages_active = false

        this.visible_pages_changes += 1
        setTimeout(() => {
          this.visible_pages_items_watch = false
        }, 200)
      }
    },

    addNewPage(list) {
      const new_page_name = this.$t("Page") + ` ${this.hidden_pages_items.length + this.visible_pages_items.length}`
      const slug = utils.slugify(new_page_name, "-")
      let page_name = this.$route.path?.split("/")[1]
      if (this.$route.path?.split("/")[2] == "forecast") {
        page_name = "forecasting"
      }
      if (this.$route?.name == "CompanyProfile") {
        page_name = "company_profile"
      }
      if (this.$route?.name == "ObjectProfile") {
        page_name = "object_profile"
      }

      const new_template = {
        id: uuid4(),
        name: new_page_name,
        slug,
        object_type: null,
        page: page_name,
        layout: [],
        is_hidden: list == "left" ? true : false
      }

      if (list == "left") {
        this.dont_trigger_hidden_pages_items_watch = true
        this.hidden_pages_items.unshift(new_template)
        this.hidden_pages_items_original.unshift(new_template)
        this.hidden_pages_search_value = ""
        this.hidden_pages_active = false

        this.hidden_pages_changes += 1

        setTimeout(() => {
          this.dont_trigger_hidden_pages_items_watch = false
        }, 200)
      } else {
        this.visible_pages_items_watch = true
        this.visible_pages_items.unshift(new_template)
        this.visible_pages_items_original.unshift(new_template)
        this.visible_pages_search_value = ""
        this.visible_pages_active = false

        this.visible_pages_changes += 1
        setTimeout(() => {
          this.visible_pages_items_watch = false
        }, 200)
      }

      return new_template

      // this.setPageLayout(new_template)
    },

    handleUpdateGroupName(group, $event) {
      if (this.hidden_pages_items.find((item) => item.is_group && item.id == group.id)) {
        const index = this.hidden_pages_items.findIndex((item) => item.is_group && item.id == group.id)
        this.hidden_pages_items.splice(index, 1, {
          ...this.hidden_pages_items[index],
          name: $event
        })
      }

      if (this.visible_pages_items.find((item) => item.is_group && item.id == group.id)) {
        const index = this.visible_pages_items.findIndex((item) => item.is_group && item.id == group.id)
        this.visible_pages_items.splice(index, 1, {
          ...this.visible_pages_items[index],
          name: $event
        })
      }
    },
    updateObjectTypeLabel(elm) {
      if (elm.objectType) {
        // old object types we need to slugify
        let object_type = utils.getObjectTypeByType(elm.objectType)
        if (object_type) {
          ObjectTypesService.updateObjectTypeLabel(object_type.id, { label: elm.name })
            .then((res) => {
              utils.replaceItem(this.hidden_pages_items, elm, "id", false)
              this.$store.commit("updateObjectType", res.data, { root: true })
            })
            .catch(() => {})
        }
      }
    },

    startDragToRightList() {
      this.drag = true
      this.tmp_list = utils.clone(this.visible_pages_items)
    },

    endDragToRightList() {
      this.element_dragged_over = null
      this.element_currently_dragged = null
      this.disable_sort = false
      this.drag = false
      let index
      this.visible_pages_items.map((item) => {
        index = this.tmp_list.findIndex((x) => x.reference_name == item.reference_name)
        if (index == -1) {
          this.visible_pages_items_original.push({ ...item, selected: false })
          const ind = this.hidden_pages_items_original.findIndex((i) => i.id == item.id)
          this.hidden_pages_items_original.splice(ind, 1)
        }
      })
    },
    startDragToLeftList() {
      this.drag = true
      this.tmp_list = utils.clone(this.hidden_pages_items)
    },
    endDragToLeftList() {
      this.drag = false
      let index
      this.hidden_pages_items.map((item) => {
        index = this.tmp_list.findIndex((x) => x.reference_name == item.reference_name)
        if (index == -1) {
          this.hidden_pages_items_original.push({ ...item, selected: false })
          const ind = this.visible_pages_items_original.findIndex((i) => i.id == item.id)
          this.visible_pages_items_original.splice(ind, 1)
        }
      })
    },
    selectDeselectAllItemsHandler(items_list, is_selected_all) {
      this.dont_trigger_hidden_pages_items_watch = true
      this.visible_pages_items_watch = true

      // in case of every thing is selected then deselect all
      if (is_selected_all) {
        items_list?.forEach((item) => {
          if (item.is_group) {
            item.pages.forEach((page) => (page.selected = false))
          } else {
            item["selected"] = false
          }
        })
      } else {
        items_list?.forEach((item) => {
          if (item.is_group) {
            item.pages.forEach((page) => (page.selected = true))
          } else {
            item["selected"] = true
          }
        })
      }

      setTimeout(() => {
        this.dont_trigger_hidden_pages_items_watch = false
        this.visible_pages_items_watch = false
      }, 200)
    },

    moveSelectedToSecondList() {
      const hidden_pages_items_calc = []

      this.hidden_pages_items.forEach((item) => {
        //item is an ungrouped page
        if (item.selected) {
          this.visible_pages_items.push({ ...item, selected: false })
          const index = this.hidden_pages_items_original.findIndex((i) => i.id == item.id)
          this.hidden_pages_items_original.splice(index, 1)
          this.visible_pages_items_original.push({ ...item, selected: false })
        }
        //item is a group
        else if (item.is_group) {
          //create and initialize new right group
          const new_right_group = this.$utils.clone(item)
          new_right_group.pages = []
          const new_left_group = this.$utils.clone(item)

          //if item is selected move from left to right group
          const new_left_group_pages_calc = []
          new_left_group.pages.forEach((page) => {
            if (page.selected) {
              new_right_group.pages.push(page)
            } else {
              new_left_group_pages_calc.push(page)
            }
          })
          new_left_group.pages = new_left_group_pages_calc

          //keep left group only if it has pages remaining
          if (new_left_group.pages.length) {
            hidden_pages_items_calc.push(new_left_group)
          }

          //create right group if pages are moved (selected)
          if (new_right_group.pages.length) {
            //if right list original already has group add pages to group else push whole group
            if (this.visible_pages_items_original.find((right_item) => right_item.is_group && right_item.id == item.id)) {
              const index = this.visible_pages_items_original.findIndex((right_item) => right_item.is_group && right_item.id == item.id)
              this.visible_pages_items_original[index].pages = this.visible_pages_items_original[index].pages.concat(
                new_right_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              )
            } else {
              this.visible_pages_items_original.push({
                ...new_right_group,
                pages: new_right_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              })
            }

            //if left list original already has group add pages to group else push whole group
            if (this.visible_pages_items.find((right_item) => right_item.is_group && right_item.id == item.id)) {
              const index = this.visible_pages_items.findIndex((right_item) => right_item.is_group && right_item.id == item.id)
              this.visible_pages_items[index].pages = this.visible_pages_items[index].pages.concat(
                new_right_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              )
            } else {
              this.visible_pages_items.push({
                ...new_right_group,
                pages: new_right_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              })
            }
          }
        } else {
          hidden_pages_items_calc.push(item)
        }
      })

      this.hidden_pages_items = hidden_pages_items_calc
    },

    moveSelectedToFirstList() {
      const visible_pages_items_calc = []

      this.visible_pages_items.forEach((item) => {
        //item is an ungrouped page
        if (item.selected) {
          this.hidden_pages_items.push({ ...item, selected: false })
          const index = this.visible_pages_items_original.findIndex((i) => i.id == item.id)
          this.visible_pages_items_original.splice(index, 1)
          this.hidden_pages_items_original.push({ ...item, selected: false })
        }
        //item is a group
        else if (item.is_group) {
          //create and initialize new left group
          const new_left_group = this.$utils.clone(item)
          new_left_group.pages = []
          const new_right_group = this.$utils.clone(item)

          //if item is selected move from right to left group
          const new_right_group_pages_calc = []
          new_right_group.pages.forEach((page) => {
            if (page.selected) {
              new_left_group.pages.push(page)
            } else {
              new_right_group_pages_calc.push(page)
            }
          })
          new_right_group.pages = new_right_group_pages_calc

          //keep right group only if it has pages remaining
          if (new_right_group.pages.length) {
            visible_pages_items_calc.push(new_right_group)
          }

          //create left group if pages are moved (selected)
          if (new_left_group.pages.length) {
            //if left list original already has group add pages to group else push whole group
            if (this.hidden_pages_items_original.find((left_item) => left_item.is_group && left_item.id == item.id)) {
              const index = this.hidden_pages_items_original.findIndex((left_item) => left_item.is_group && left_item.id == item.id)
              this.hidden_pages_items_original[index].pages = this.hidden_pages_items_original[index].pages.concat(
                new_left_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              )
            } else {
              this.hidden_pages_items_original.push({
                ...new_left_group,
                pages: new_left_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              })
            }

            //if right list original already has group add pages to group else push whole group
            if (this.hidden_pages_items.find((left_item) => left_item.is_group && left_item.id == item.id)) {
              const index = this.hidden_pages_items.findIndex((left_item) => left_item.is_group && left_item.id == item.id)
              this.hidden_pages_items[index].pages = this.hidden_pages_items[index].pages.concat(
                new_left_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              )
            } else {
              this.hidden_pages_items.push({
                ...new_left_group,
                pages: new_left_group.pages.map((p) => {
                  return { ...p, selected: false }
                })
              })
            }
          }
        } else {
          visible_pages_items_calc.push(item)
        }
      })

      this.visible_pages_items = visible_pages_items_calc
    },

    handleSelectItem(item) {
      this.dont_trigger_hidden_pages_items_watch = true
      this.visible_pages_items_watch = true
      if (item.is_group) {
        if (item.pages.filter((p) => p.selected).length == item.pages.length) {
          item.pages.forEach((item) => (item.selected = false))
        } else {
          item.pages.forEach((item) => (item.selected = true))
        }
      } else {
        item.selected = !item.selected
      }
      setTimeout(() => {
        this.dont_trigger_hidden_pages_items_watch = false
        this.visible_pages_items_watch = false
      }, 200)
    },

    getValue(item) {
      if (typeof item == "object" && this.valueAttr) {
        return item[this.valueAttr]
      }
      return item
    }
  }
}
</script>
<style scoped>
.secondary-btn {
  background-color: #f8f9fa;
  color: #6c757d;
}
.ghost {
  @apply opacity-50 bg-white border-0;
}
.chosen {
  @apply opacity-50 bg-white border-0;
}
.flip-list {
  transition: all 0.25s ease-out;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}
</style>
